/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface CreateSectionRequest
 */
export interface CreateSectionRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateSectionRequest
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateSectionRequest
     */
    isDraft?: boolean;
}

/**
 * Check if a given object implements the CreateSectionRequest interface.
 */
export function instanceOfCreateSectionRequest(value: object): boolean {
    return true;
}

export function CreateSectionRequestFromJSON(json: any): CreateSectionRequest {
    return CreateSectionRequestFromJSONTyped(json, false);
}

export function CreateSectionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSectionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'isDraft': json['isDraft'] == null ? undefined : json['isDraft'],
    };
}

export function CreateSectionRequestToJSON(value?: CreateSectionRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'isDraft': value['isDraft'],
    };
}

